import { GetStaticProps } from 'next';
import ScreenError from '@/components/ScreenError/ScreenError';
import React from 'react';
import Icon404 from '../public/static/svg/404.svg';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';

type Props = {
  isEmptyVideoUrl?: boolean;
};

const VideoUnavailable = ({ isEmptyVideoUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>Video Unavailable | Butaca</title>
      </Head>
      <ScreenError
        code="404"
        Icon={Icon404}
        title={t('videoUnavailable')}
        subtitle={
          isEmptyVideoUrl
            ? t('videoUnavailableAtTheMomentMessage')
            : t('videoUnavailableMessage')
        }
      />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'profile'])),
    },
  };
};

export default VideoUnavailable;
